// extracted by mini-css-extract-plugin
export default {"notes_panel_default_button":"notespanel_notes_panel_default_button__U1Z6E","notes_editor_button":"notespanel_notes_editor_button__Gk7a6"};